import { makeStyles } from '@mui/styles';
import theme from 'theme';

const useStyles = makeStyles(() => ({
    root: {
        flexGrow: 1,
        position: 'relative',
    },
    paper: {
        padding: theme.spacing(2),
        borderRadius: 4,
    },

    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(3),
        paddingBottom: theme.spacing(2),
        borderBottom: `1px solid #E4E4E4`,

        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            gap: 12,
        },
    },
}));

export default useStyles;
